import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import FetchApi from '../../customhooks/functionFetchApi';
import { Button } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ViewProductionsyspartb from './veiwproductionsyspartb';

const objectPartB = {
    tecbid: "",
    sequence: "",
    bodyside: "",
    bodycolor: "",
    bodyfm: "",
    bodydfw_min: "",
    bodydfw_max: "",
    bodywfw: "",
    bodytemp: "",
    bodyspeed: "",
    bodyrubber: "",
    topside: "",
    topcolor: "",
    topfm: "",
    topdfw_min: "",
    topdfw_max: "",
    topwfw: "",
    toptemp: "",
    topspeed: "",
    toprubber: "",
    bottomside: "",
    bottomcolor: "",
    bottomfm: "",
    bottomdfw_min: "",
    bottomdfw_max: "",
    bottomwfw: "",
    bottomtemp: "",
    bottomspeed: "",
    bottomrubber: "",
    otherdetail: "",
    journalId: "",
    tdscode: "",
    rfFgbody:"",
    rfFgtop:"",
    rfFgbottom:"",
}


const AllDetailpartb = ({ journalId }) => {

    const FetchApis = new FetchApi();
    const [key, setKey] = useState('partB');
    const [jouranldata, setJournaldata] = useState([]);

    const [coanting1st, setCoanting1st] = useState(objectPartB);
    const [coanting2nd, setCoanting2nd] = useState(objectPartB);
    const [coanting3rd, setCoanting3rd] = useState(objectPartB);
    const [coanting4th, setCoanting4th] = useState(objectPartB);
    const [coanting5th, setCoanting5th] = useState(objectPartB);
    const [coanting6th, setCoanting6th] = useState(objectPartB);
    const [coanting7th, setCoanting7th] = useState(objectPartB);

    const [checkdata, setCheckdata] = useState(false);

    useEffect(() => {

        loadigndatajourng()

    }, [])

    function loadigndatajourng(){
        FetchApis.FethcGet(`/technical/techniaclByJournalId/${journalId}`).then((res) => {

            if (res.status == 200) {
                if (res.data.data.length != 0) {
                    setCheckdata(true)
                    Coatinglistbytype(res.data.data)
                }
                datalistjournal()
            }
        })
    }


    function datalistjournal() {
        FetchApis.FethcGet(`/journal/journalbyId/${journalId}`).then((res) => {
            if (res) {
                setJournaldata(res.data.data[0]);
            }
        })
    }

    function Coatinglistbytype(datalist) {
        const coating1st = datalist.find((item) => item.sequence == '1st');
        setCoanting1st(coating1st || objectPartB);

        const coating2nd = datalist.find((item) => item.sequence == '2nd');
        setCoanting2nd(coating2nd || objectPartB);

        const coating3rd = datalist.find((item) => item.sequence == '3rd');
        setCoanting3rd(coating3rd || objectPartB);

        const coating4th = datalist.find((item) => item.sequence == '4th');
        setCoanting4th(coating4th || objectPartB);

        const coating5th = datalist.find((item) => item.sequence == '5th');
        setCoanting5th(coating5th || objectPartB);

        const coating6th = datalist.find((item) => item.sequence == '6th');
        setCoanting6th(coating6th || objectPartB);

        const coating7th = datalist.find((item) => item.sequence == '7th');
        setCoanting7th(coating7th || objectPartB);
    }

    // type (body / top / bottom) ที่มีการ Add Additive ในลำดับใดลำดับหนึ่ง จะแสดงคอลัมน์ Additive ต่อจากคอลัมน์นั้น
    const additiveTypes = ['body', 'top', 'bottom'].filter((type) =>
        [coanting1st, coanting2nd, coanting3rd, coanting4th, coanting5th, coanting6th, coanting7th]
            .some((coating) => coating && coating[type + 'additive'] == 1));

    // แบ่งความกว้าง 55% ให้ Body / Top / Bottom และคอลัมน์ Additive (Additive แคบกว่า) ให้ชิดกันพอดี
    const typeWidth = `${55 / (3 + 0.8 * additiveTypes.length)}%`;
    const additiveWidth = `${55 * 0.8 / (3 + 0.8 * additiveTypes.length)}%`;
    const additiveStyle = { backgroundColor: 'rgba(255, 193, 7, 0.08)' };

    function additiveCell(coating, type, field) {
        if (!additiveTypes.includes(type)) return null;
        return <td style={additiveStyle}>{coating && field && coating[type + 'additive'] == 1 && coating[type + field]}</td>;
    }

    return (
        <div style={{ color: 'black' }}>{checkdata == false ? <div>
            <div className='row-page-box'>
                ยังไม่มีข้อมูล Part B
            </div>

        </div> : <div style={{width:'100%'}}>
            <div className='end-flex-row'>
            </div>
            <div className='row-between-page' style={{ backgroundColor: '#CDCBC7', padding: 10, borderRadius: 5, width: '100%' }}>
                <div style={{ width: '70%' }}><b>TECHNICAL DATA SHEET PART B </b> </div>
                <div style={{ width: '20%' }}><b>Ref .MK {jouranldata.tdscode}</b></div>
                <div style={{ width: '10%' }}><b>Date : {jouranldata.createdate}</b></div>
            </div>


            <div >
                <Tabs
                    id="controlled-tab-example"
                    activeKey={key}
                    onSelect={(k) => setKey(k)}
                    className="mb-3"
                    style={{ '--bs-nav-link-color': 'black', '--bs-nav-tabs-link-active-color': 'black' }}
                >
                    <Tab eventKey="partB" title="Technical data sheet part B">
                        <div style={{ width: '100%', color: 'black' }}>


                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}><center>Coating system</center></th>
                                    <th style={{ width: typeWidth }}><center>Body</center></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center>Body Additive</center></th>}
                                    <th style={{ width: typeWidth }}><center>Top end</center></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center>Top end Additive</center></th>}
                                    <th style={{ width: typeWidth }}><center>Bottom end</center></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center>Bottom end Additive</center></th>}
                                    <th style={{ width: '20%' }}><center>Other</center></th>
                                </tr>
                                <tr>
                                    <td ><center><b> </b></center></td>
                                    <td > <b>Ref . FG</b></td>
                                    <td ><b>{coanting1st.rfFgbody}</b></td>
                                    {additiveCell(coanting1st, 'body', null)}
                                    <td ><b>{coanting1st.rfFgtop}</b></td>
                                    {additiveCell(coanting1st, 'top', null)}
                                    <td ><b>{coanting1st.rfFgbottom}</b></td>
                                    {additiveCell(coanting1st, 'bottom', null)}
                                    <div style={{ padding: 5 }}>{coanting1st.otherdetail}</div>
                                </tr>
                                <tr>
                                    <td ><center><b>1 st </b></center></td>
                                    <td >Side</td>
                                    <td >{coanting1st.bodyside}</td>
                                    {additiveCell(coanting1st, 'body', null)}
                                    <td >{coanting1st.topside}</td>
                                    {additiveCell(coanting1st, 'top', null)}
                                    <td >{coanting1st.bottomside}</td>
                                    {additiveCell(coanting1st, 'bottom', null)}
                                    <div style={{ padding: 5 }}></div>
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Color shade</td>
                                    <td >{coanting1st.bodycolor}</td>
                                    {additiveCell(coanting1st, 'body', 'additive_name')}
                                    <td >{coanting1st.topcolor}</td>
                                    {additiveCell(coanting1st, 'top', 'additive_name')}
                                    <td >{coanting1st.bottomcolor}</td>
                                    {additiveCell(coanting1st, 'bottom', 'additive_name')}
                                    {/* <td style={{ width: '20%' }}></td> */}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting1st.bodyfm}</td>
                                    {additiveCell(coanting1st, 'body', 'additive_fm')}
                                    <td >{coanting1st.topfm}</td>
                                    {additiveCell(coanting1st, 'top', 'additive_fm')}
                                    <td >{coanting1st.bottomfm}</td>
                                    {additiveCell(coanting1st, 'bottom', 'additive_fm')}
                                    {/* <td style={{ width: '20%' }}></td> */}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting1st.bodydfw_min != "" && <div>{coanting1st.bodydfw_min} - {coanting1st.bodydfw_max} / {coanting1st.bodywfw}</div>}</td>
                                    {additiveCell(coanting1st, 'body', 'additive_weight')}
                                    <td >{coanting1st.topdfw_min != "" && <div>{coanting1st.topdfw_min} - {coanting1st.topdfw_max} / {coanting1st.topwfw}</div>}</td>
                                    {additiveCell(coanting1st, 'top', 'additive_weight')}
                                    <td >{coanting1st.bottomdfw_min != "" && <div>{coanting1st.bottomdfw_min} - {coanting1st.bottomdfw_max} / {coanting1st.bottomwfw}</div>}</td>
                                    {additiveCell(coanting1st, 'bottom', 'additive_weight')}

                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C )</td>
                                    <td >{coanting1st.bodytemp}</td>
                                    {additiveCell(coanting1st, 'body', null)}
                                    <td >{coanting1st.toptemp}</td>
                                    {additiveCell(coanting1st, 'top', null)}
                                    <td >{coanting1st.bottomtemp}</td>
                                    {additiveCell(coanting1st, 'bottom', null)}
                                    {/* <td style={{ width: '20%' }}></td> */}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td ><div>{coanting1st.bodyspeed != "" ? <div>{coanting1st.bodyspeed} / {coanting1st.bodyrubber}</div> : <div></div>}</div></td>
                                    {additiveCell(coanting1st, 'body', null)}
                                    <td ><div>{coanting1st.topspeed != "" ? <div>{coanting1st.topspeed} / {coanting1st.toprubber}</div> : <div></div>}</div></td>
                                    {additiveCell(coanting1st, 'top', null)}
                                    <td ><div>{coanting1st.bottomspeed != "" ? <div> {coanting1st.bottomspeed} / {coanting1st.bottomrubber}</div> : <div></div>} </div></td>
                                    {additiveCell(coanting1st, 'bottom', null)}
                                    {/* <td style={{ width: '20%' }}></td> */}
                                </tr>
                            </table>


                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}></th>
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                                <tr>
                                    <td ><center><b>2 nd  </b></center></td>
                                    <td >Side</td>
                                    <td >{coanting2nd.bodyside}</td>
                                    {additiveCell(coanting2nd, 'body', null)}
                                    <td >{coanting2nd.topside}</td>
                                    {additiveCell(coanting2nd, 'top', null)}
                                    <td >{coanting2nd.bottomside}</td>
                                    {additiveCell(coanting2nd, 'bottom', null)}
                                    <div style={{ padding: 5 }}>{coanting2nd.otherdetail}</div>
                                </tr>
                                <tr>
                                    <td ><center><b></b></center></td>
                                    <td >Color shade</td>
                                    <td >{coanting2nd.bodycolor}</td>
                                    {additiveCell(coanting2nd, 'body', 'additive_name')}
                                    <td >{coanting2nd.topcolor}</td>
                                    {additiveCell(coanting2nd, 'top', 'additive_name')}
                                    <td >{coanting2nd.bottomcolor}</td>
                                    {additiveCell(coanting2nd, 'bottom', 'additive_name')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting2nd.bodyfm}</td>
                                    {additiveCell(coanting2nd, 'body', 'additive_fm')}
                                    <td >{coanting2nd.topfm}</td>
                                    {additiveCell(coanting2nd, 'top', 'additive_fm')}
                                    <td >{coanting2nd.bottomfm}</td>
                                    {additiveCell(coanting2nd, 'bottom', 'additive_fm')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting2nd.bodydfw_min != "" && <div>{coanting2nd.bodydfw_min} - {coanting2nd.bodydfw_max} / {coanting2nd.bodywfw}</div>}</td>
                                    {additiveCell(coanting2nd, 'body', 'additive_weight')}
                                    <td >{coanting2nd.topdfw_min != "" && <div>{coanting2nd.topdfw_min} - {coanting2nd.topdfw_max} / {coanting2nd.topwfw}</div>}</td>
                                    {additiveCell(coanting2nd, 'top', 'additive_weight')}
                                    <td >{coanting2nd.bottomdfw_min != "" && <div>{coanting2nd.bottomdfw_min} - {coanting2nd.bottomdfw_max} / {coanting2nd.bottomwfw}</div>}</td>
                                    {additiveCell(coanting2nd, 'bottom', 'additive_weight')}

                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C ) </td>
                                    <td >{coanting2nd.bodytemp}</td>
                                    {additiveCell(coanting2nd, 'body', null)}
                                    <td >{coanting2nd.toptemp}</td>
                                    {additiveCell(coanting2nd, 'top', null)}
                                    <td >{coanting2nd.bottomtemp}</td>
                                    {additiveCell(coanting2nd, 'bottom', null)}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td >{coanting2nd.bodyspeed != "" ? <div>{coanting2nd.bodyspeed} / {coanting2nd.bodyrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting2nd, 'body', null)}
                                    <td >{coanting2nd.topspeed != "" ? <div>{coanting2nd.topspeed} / {coanting2nd.toprubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting2nd, 'top', null)}
                                    <td >{coanting2nd.bottomspeed != "" ? <div>{coanting2nd.bottomspeed} / {coanting2nd.bottomrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting2nd, 'bottom', null)}
                                </tr>
                            </table>

                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}></th>
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                                <tr>
                                    <td ><center><b>3 rd  </b></center></td>
                                    <td >Side</td>
                                    <td >{coanting3rd.bodyside}</td>
                                    {additiveCell(coanting3rd, 'body', null)}
                                    <td >{coanting3rd.topside}</td>
                                    {additiveCell(coanting3rd, 'top', null)}
                                    <td >{coanting3rd.bottomside}</td>
                                    {additiveCell(coanting3rd, 'bottom', null)}
                                    <div style={{ padding: 5 }}>{coanting3rd.otherdetail}</div>
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Color shade</td>
                                    <td >{coanting3rd.bodycolor}</td>
                                    {additiveCell(coanting3rd, 'body', 'additive_name')}
                                    <td >{coanting3rd.topcolor}</td>
                                    {additiveCell(coanting3rd, 'top', 'additive_name')}
                                    <td >{coanting3rd.bottomcolor}</td>
                                    {additiveCell(coanting3rd, 'bottom', 'additive_name')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting3rd.bodyfm}</td>
                                    {additiveCell(coanting3rd, 'body', 'additive_fm')}
                                    <td >{coanting3rd.topfm}</td>
                                    {additiveCell(coanting3rd, 'top', 'additive_fm')}
                                    <td >{coanting3rd.bottomfm}</td>
                                    {additiveCell(coanting3rd, 'bottom', 'additive_fm')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting3rd.bodydfw_min != "" && <div>{coanting3rd.bodydfw_min} - {coanting3rd.bodydfw_max} / {coanting3rd.bodywfw}</div>}</td>
                                    {additiveCell(coanting3rd, 'body', 'additive_weight')}
                                    <td >{coanting3rd.topdfw_min != "" && <div>{coanting3rd.topdfw_min} - {coanting3rd.topdfw_max} / {coanting3rd.topwfw}</div>}</td>
                                    {additiveCell(coanting3rd, 'top', 'additive_weight')}
                                    <td >{coanting3rd.bottomdfw_min != "" && <div>{coanting3rd.bottomdfw_min} - {coanting3rd.bottomdfw_max} / {coanting3rd.bottomwfw}</div>}</td>
                                    {additiveCell(coanting3rd, 'bottom', 'additive_weight')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C ) </td>
                                    <td >{coanting3rd.bodytemp}</td>
                                    {additiveCell(coanting3rd, 'body', null)}
                                    <td >{coanting3rd.toptemp}</td>
                                    {additiveCell(coanting3rd, 'top', null)}
                                    <td >{coanting3rd.bottomtemp}</td>
                                    {additiveCell(coanting3rd, 'bottom', null)}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td >{coanting3rd.bodyspeed != "" ? <div>{coanting3rd.bodyspeed} / {coanting3rd.bodyrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting3rd, 'body', null)}
                                    <td >{coanting3rd.topspeed != "" ? <div>{coanting3rd.topspeed} / {coanting3rd.toprubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting3rd, 'top', null)}
                                    <td >{coanting3rd.bottomspeed != "" ? <div>{coanting3rd.bottomspeed} / {coanting3rd.bottomrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting3rd, 'bottom', null)}
                                </tr>
                            </table>


                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}></th>
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                                <tr>
                                    <td ><center><b>4 th  </b></center></td>
                                    <td >Side</td>
                                    <td >{coanting4th.bodyside}</td>
                                    {additiveCell(coanting4th, 'body', null)}
                                    <td >{coanting4th.topside}</td>
                                    {additiveCell(coanting4th, 'top', null)}
                                    <td >{coanting4th.bottomside}</td>
                                    {additiveCell(coanting4th, 'bottom', null)}
                                    <div style={{ padding: 5 }}>{coanting4th.otherdetail}</div>
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Color shade</td>
                                    <td >{coanting4th.bodycolor}</td>
                                    {additiveCell(coanting4th, 'body', 'additive_name')}
                                    <td >{coanting4th.topcolor}</td>
                                    {additiveCell(coanting4th, 'top', 'additive_name')}
                                    <td >{coanting4th.bottomcolor}</td>
                                    {additiveCell(coanting4th, 'bottom', 'additive_name')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting4th.bodyfm}</td>
                                    {additiveCell(coanting4th, 'body', 'additive_fm')}
                                    <td >{coanting4th.topfm}</td>
                                    {additiveCell(coanting4th, 'top', 'additive_fm')}
                                    <td >{coanting4th.bottomfm}</td>
                                    {additiveCell(coanting4th, 'bottom', 'additive_fm')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting4th.bodydfw_min != "" && <div>{coanting4th.bodydfw_min} - {coanting4th.bodydfw_max} / {coanting4th.bodywfw}</div>}</td>
                                    {additiveCell(coanting4th, 'body', 'additive_weight')}
                                    <td >{coanting4th.topdfw_min != "" && <div>{coanting4th.topdfw_min} - {coanting4th.topdfw_max} / {coanting4th.topwfw}</div>}</td>
                                    {additiveCell(coanting4th, 'top', 'additive_weight')}
                                    <td >{coanting4th.bottomdfw_min != "" && <div>{coanting4th.bottomdfw_min} - {coanting4th.bottomdfw_max} / {coanting4th.bottomwfw}</div>}</td>
                                    {additiveCell(coanting4th, 'bottom', 'additive_weight')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C )</td>
                                    <td >{coanting4th.bodytemp}</td>
                                    {additiveCell(coanting4th, 'body', null)}
                                    <td >{coanting4th.toptemp}</td>
                                    {additiveCell(coanting4th, 'top', null)}
                                    <td >{coanting4th.bottomtemp}</td>
                                    {additiveCell(coanting4th, 'bottom', null)}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td >{coanting4th.bodyspeed != "" ? <div>{coanting4th.bodyspeed} / {coanting4th.bodyrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting4th, 'body', null)}
                                    <td >{coanting4th.topspeed != "" ? <div>{coanting4th.topspeed} / {coanting4th.toprubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting4th, 'top', null)}
                                    <td >{coanting4th.bottomspeed != "" ? <div>{coanting4th.bottomspeed} /{coanting4th.bottomrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting4th, 'bottom', null)}
                                </tr>
                            </table>


                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}></th>
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                                <tr>
                                    <td ><center><b>5 th  </b></center></td>
                                    <td >Side</td>
                                    <td >{coanting5th.bodyside}</td>
                                    {additiveCell(coanting5th, 'body', null)}
                                    <td >{coanting5th.topside}</td>
                                    {additiveCell(coanting5th, 'top', null)}
                                    <td >{coanting5th.bottomside}</td>
                                    {additiveCell(coanting5th, 'bottom', null)}
                                    <div style={{ padding: 5 }}>{coanting5th.otherdetail}</div>
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Color shade</td>
                                    <td >{coanting5th.bodycolor}</td>
                                    {additiveCell(coanting5th, 'body', 'additive_name')}
                                    <td >{coanting5th.topcolor}</td>
                                    {additiveCell(coanting5th, 'top', 'additive_name')}
                                    <td >{coanting5th.bottomcolor}</td>
                                    {additiveCell(coanting5th, 'bottom', 'additive_name')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting5th.bodyfm}</td>
                                    {additiveCell(coanting5th, 'body', 'additive_fm')}
                                    <td >{coanting5th.topfm}</td>
                                    {additiveCell(coanting5th, 'top', 'additive_fm')}
                                    <td >{coanting5th.bottomfm}</td>
                                    {additiveCell(coanting5th, 'bottom', 'additive_fm')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting5th.bodydfw_min != "" && <div>{coanting5th.bodydfw_min} - {coanting5th.bodydfw_max} / {coanting5th.bodywfw}</div>}</td>
                                    {additiveCell(coanting5th, 'body', 'additive_weight')}
                                    <td >{coanting5th.topdfw_min != "" && <div>{coanting5th.topdfw_min} - {coanting5th.topdfw_max} / {coanting5th.topwfw}</div>}</td>
                                    {additiveCell(coanting5th, 'top', 'additive_weight')}
                                    <td >{coanting5th.bottomdfw_min != "" && <div>{coanting5th.bottomdfw_min} - {coanting5th.bottomdfw_max} / {coanting5th.bottomwfw}</div>}</td>
                                    {additiveCell(coanting5th, 'bottom', 'additive_weight')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C ) </td>
                                    <td >{coanting5th.bodytemp}</td>
                                    {additiveCell(coanting5th, 'body', null)}
                                    <td >{coanting5th.toptemp}</td>
                                    {additiveCell(coanting5th, 'top', null)}
                                    <td >{coanting5th.bottomtemp}</td>
                                    {additiveCell(coanting5th, 'bottom', null)}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td >{coanting5th.bodyspeed != "" ? <div>{coanting5th.bodyspeed} / {coanting5th.bodyrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting5th, 'body', null)}
                                    <td >{coanting5th.topspeed != "" ? <div>{coanting5th.topspeed} / {coanting5th.toprubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting5th, 'top', null)}
                                    <td >{coanting5th.bottomspeed != "" ? <div>{coanting5th.bottomspeed} / {coanting5th.bottomrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting5th, 'bottom', null)}
                                </tr>
                            </table>


                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}></th>
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                                <tr>
                                    <td ><center><b>6 th  </b></center></td>
                                    <td >Side</td>
                                    <td >{coanting6th.bodyside}</td>
                                    {additiveCell(coanting6th, 'body', null)}
                                    <td >{coanting6th.topside}</td>
                                    {additiveCell(coanting6th, 'top', null)}
                                    <td >{coanting6th.bottomside}</td>
                                    {additiveCell(coanting6th, 'bottom', null)}
                                    <div style={{ padding: 5 }}>{coanting6th.otherdetail}</div>
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Color shade</td>
                                    <td >{coanting6th.bodycolor}</td>
                                    {additiveCell(coanting6th, 'body', 'additive_name')}
                                    <td >{coanting6th.topcolor}</td>
                                    {additiveCell(coanting6th, 'top', 'additive_name')}
                                    <td >{coanting6th.bottomcolor}</td>
                                    {additiveCell(coanting6th, 'bottom', 'additive_name')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting6th.bodyfm}</td>
                                    {additiveCell(coanting6th, 'body', 'additive_fm')}
                                    <td >{coanting6th.topfm}</td>
                                    {additiveCell(coanting6th, 'top', 'additive_fm')}
                                    <td >{coanting6th.bottomfm}</td>
                                    {additiveCell(coanting6th, 'bottom', 'additive_fm')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting6th.bodydfw_min != "" && <div>{coanting6th.bodydfw_min} - {coanting6th.bodydfw_max} / {coanting6th.bodywfw}</div>}</td>
                                    {additiveCell(coanting6th, 'body', 'additive_weight')}
                                    <td >{coanting6th.topdfw_min != "" && <div>{coanting6th.topdfw_min} - {coanting6th.topdfw_max} / {coanting6th.topwfw}</div>}</td>
                                    {additiveCell(coanting6th, 'top', 'additive_weight')}
                                    <td >{coanting6th.bottomdfw_min != "" && <div>{coanting6th.bottomdfw_min} - {coanting6th.bottomdfw_max} / {coanting6th.bottomwfw}</div>}</td>
                                    {additiveCell(coanting6th, 'bottom', 'additive_weight')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C ) </td>
                                    <td >{coanting6th.bodytemp}</td>
                                    {additiveCell(coanting6th, 'body', null)}
                                    <td >{coanting6th.toptemp}</td>
                                    {additiveCell(coanting6th, 'top', null)}
                                    <td >{coanting6th.bottomtemp}</td>
                                    {additiveCell(coanting6th, 'bottom', null)}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td >{coanting6th.bodyspeed != "" ? <div>{coanting6th.bodyspeed} / {coanting6th.bodyrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting6th, 'body', null)}
                                    <td >{coanting6th.topspeed != "" ? <div>{coanting6th.topspeed} / {coanting6th.toprubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting6th, 'top', null)}
                                    <td >{coanting6th.bottomspeed != "" ? <div>{coanting6th.bottomspeed} / {coanting6th.bottomrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting6th, 'bottom', null)}
                                </tr>
                            </table>


                            <table style={{ width: '100%' }}>
                                <tr>
                                    <th style={{ width: '5%' }}><center>sequence</center></th>
                                    <th style={{ width: '20%' }}></th>
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('body') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('top') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: typeWidth }}></th>
                                    {additiveTypes.includes('bottom') && <th style={{ width: additiveWidth }}><center></center></th>}
                                    <th style={{ width: '20%' }}></th>
                                </tr>
                                <tr>
                                    <td ><center><b>7 th  </b></center></td>
                                    <td >Varnish top coat</td>
                                    <td >{coanting7th.bodyside}</td>
                                    {additiveCell(coanting7th, 'body', null)}
                                    <td >{coanting7th.topside}</td>
                                    {additiveCell(coanting7th, 'top', null)}
                                    <td >{coanting7th.bottomside}</td>
                                    {additiveCell(coanting7th, 'bottom', null)}
                                    <div >{coanting7th.otherdetail}</div>

                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Color shade</td>
                                    <td >{coanting7th.bodycolor}</td>
                                    {additiveCell(coanting7th, 'body', 'additive_name')}
                                    <td >{coanting7th.topcolor}</td>
                                    {additiveCell(coanting7th, 'top', 'additive_name')}
                                    <td >{coanting7th.bottomcolor}</td>
                                    {additiveCell(coanting7th, 'bottom', 'additive_name')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >FM.code</td>
                                    <td >{coanting7th.bodyfm}</td>
                                    {additiveCell(coanting7th, 'body', 'additive_fm')}
                                    <td >{coanting7th.topfm}</td>
                                    {additiveCell(coanting7th, 'top', 'additive_fm')}
                                    <td >{coanting7th.bottomfm}</td>
                                    {additiveCell(coanting7th, 'bottom', 'additive_fm')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >DFW ( gsm ) / wfw (Kg / 1000 Sht)</td>
                                    <td >{coanting7th.bodydfw_min != "" && <div>{coanting7th.bodydfw_min} - {coanting7th.bodydfw_max} / {coanting7th.bodywfw}</div>}</td>
                                    {additiveCell(coanting7th, 'body', 'additive_weight')}
                                    <td >{coanting7th.topdfw_min != "" && <div>{coanting7th.topdfw_min} - {coanting7th.topdfw_max} / {coanting7th.topwfw}</div>}</td>
                                    {additiveCell(coanting7th, 'top', 'additive_weight')}
                                    <td >{coanting7th.bottomdfw_min != "" && <div>{coanting7th.bottomdfw_min} - {coanting7th.bottomdfw_max} / {coanting7th.bottomwfw}</div>}</td>
                                    {additiveCell(coanting7th, 'bottom', 'additive_weight')}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Temp ( C )</td>
                                    <td >{coanting7th.bodytemp}</td>
                                    {additiveCell(coanting7th, 'body', null)}
                                    <td >{coanting7th.toptemp}</td>
                                    {additiveCell(coanting7th, 'top', null)}
                                    <td >{coanting7th.bottomtemp}</td>
                                    {additiveCell(coanting7th, 'bottom', null)}
                                </tr>
                                <tr>
                                    <td ></td>
                                    <td >Speed ( sph) / No .Rubber</td>
                                    <td >{coanting7th.bodyspeed != "" ? <div>{coanting7th.bodyspeed} / {coanting7th.bodyrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting7th, 'body', null)}
                                    <td >{coanting7th.topspeed != "" ? <div>{coanting7th.topspeed} / {coanting7th.toprubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting7th, 'top', null)}
                                    <td >{coanting7th.bottomspeed != "" ? <div>{coanting7th.bottomspeed} / {coanting7th.bottomrubber}</div> : <div></div>}</td>
                                    {additiveCell(coanting7th, 'bottom', null)}
                                </tr>
                            </table>
                            <ViewProductionsyspartb journalId={journalId}/>
                        </div>
                    </Tab>
                </Tabs>
            </div>

        </div>}
        </div>
    )
}

export default AllDetailpartb